<div class="wrap">
  <div class="validation" *ngIf="isSuccessful !== null" [style.height]="isSuccessful ? '50%' :'60%'">

    <a href="https://www.ramdamfestival.be/" target="_blank" class="ramdam" ><img  src="assets/img/TOURNAI RAMDAM FEST - logo BLC&RGE.png" alt="logo_ramdam"></a>

    <div class="powered_by_bizzdev">
      <span>Powered by</span>
      <div class="bizzdev">
        <img src="assets/icons/logo_bizzdev.jpg" alt=""> 
        <a href="https://www.bizzdev.com/" target="_blank"> BizzDev</a>
      </div>
    </div>
  
    <app-validation-animation [text]="'Votre compte a été validé'" *ngIf="isSuccessful"></app-validation-animation>
    <app-error-animation [text]="'Votre compte n\'a pas pu être validé'" *ngIf="!isSuccessful" ></app-error-animation>
   
  </div>
</div >

